import React from 'react';
import { widget } from '../../charting_library';
import Datafeed from './api/';
import StorageApi from './storageApi/';

import ApiHelper from '../../api/apiHelper';
const apiHelper = new ApiHelper();

const indices = [ "HKEX:HKEX:HSI", "US:US:US500", "JP:JP:N225", "CN:CN:CSI300", "TW:TW:TAIEX" ];

const isMobile = () => {
	var check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
};

const RS_LINE_SCALE = 2;
const PRICE_SCALE = 3;

export default class TVChartContainer extends React.PureComponent
{
	static defaultProps = {
		symbol: 'HKEX:HSI',
		interval: '1D',
		containerId: 'tv_chart_container',
		datafeedUrl: process.env.REACT_APP_FINETIC_API_URL + 'tvchart',
		timezone: "exchange",
		libraryPath: '/charting_library/',
		clientId: 'app.finetic.ai',
		fullscreen: false,
		autosize: false,
		overrides: {
			"mainSeriesProperties.style": 0,
			"mainSeriesProperties.candleStyle.barColorsOnPrevClose": true,
			"mainSeriesProperties.haStyle.barColorsOnPrevClose": true,
			"mainSeriesProperties.barStyle.barColorsOnPrevClose": true,
		},
		studiesOverrides: {
			"volume.color based on previous close": true
		},
		locale: 'en',
		className: '',
		timeframe: isMobile() ? '3m' : '6m',
		time_frames: [
			{ text: "1y", resolution: "1D", description: "1 Year", title: "1y" },
			{ text: "6m", resolution: "1D", description: "6 Months", title: "6m" },
			{ text: "3m", resolution: "1D", description: "3 Months", title: "3m" },
			{ text: "1m", resolution: "1D", description: "1 Month", title: "1m" },
		],
		disabledFeatures: [ "left_toolbar" ],
		enabledFeatures: [ "study_templates" ],
		onReadyCallback: () => { },
		hideRSLine: false,
	};

	tvWidget = null;
	patterns = [];

	volumeMaEntityId = null;
	priceMaEntityId = null;
	rsLineEntityId = null;

	constructor(props)
	{
		super(props);

		this.onPatternCallback = this.onPatternCallback.bind(this);
		this.createStudies = this.createStudies.bind(this);
		this.onChartReady = this.onChartReady.bind(this);
	}

	componentDidMount()
	{
		const datafeed = new Datafeed(this.props.getAccessTokenSilently, this.onPatternCallback, this.props.streamingApi);
		const storageApi = new StorageApi(this.props.getAccessTokenSilently, this.props.clientId, this.props.userId);

		const widgetOptions = {
			symbol: this.props.symbol,
			// BEWARE: no trailing slash is expected in feed URL
			// datafeed: new window.Datafeeds.UDFCompatibleDatafeed(this.props.datafeedUrl),
			datafeed: datafeed,
			interval: this.props.interval,
			container_id: this.props.containerId,
			timezone: this.props.timezone,
			library_path: this.props.libraryPath,

			locale: this.props.locale || 'en',
			disabled_features: [ ...this.props.disabledFeatures, ...TVChartContainer.defaultProps.disabledFeatures ],
			enabled_features: this.props.enabledFeatures,
			save_load_adapter: storageApi,
			client_id: this.props.clientId,
			user_id: this.props.userId,
			fullscreen: this.props.fullscreen,
			autosize: this.props.autosize,
			overrides: this.props.overrides,
			timeframe: this.props.timeframe,
			time_frames: this.props.time_frames,
			studies_overrides: this.props.studiesOverrides,
			preset: this.props.preset,
			custom_indicators_getter: function(PineJS) {
				return Promise.resolve([
					{
						name: 'RS Line',
						metainfo: {
							_metainfoVersion: 51,
							id: 'RSLine@tv-basicstudies-1',
							description: 'RS Line',
							shortDescription: 'RS Line',
							is_hidden_study: true,
							is_price_study: true,
							isCustomIndicator: true,
							format: {
								type: 'price',
								precision: 2,
							},
			
							plots: [
								{ id: 'rsLine', type: 'line' },
								{ id: 'rsLineNewHighBeforeCloseHigh', type: 'shapes' },
							],
							defaults: {
								styles: {
									rsLine: {
										linestyle: 0,
										visible: true,
										linewidth: 1,
										plottype: 2,
			
										// Show price line?
										trackPrice: false,
			
										// Plot color
										color: 'rgba(255, 176, 102, 0.7)'
									},
									rsLineNewHighBeforeCloseHigh: {
										plottype: 'shape_circle',
										location: 'Absolute',

										// Plot color
										color: '#E040FB'
									},
								},
								precision: 2,
								inputs: {
									index: "HKEX:HSI",
									rsLineVerticalOffset: 0,
									recentHighLookback: 52,
								}
							},
							styles: {
								rsLine: {
									title: 'RS Line',
									histogramBase: 0,
								},
								rsLineNewHighBeforeCloseHigh: {
									title: 'RS Line New High before Close High Indicator',
									histogramBase: 0,
									size: 'small',
								},
							},
							'inputs': [
								{
									id: "index",
									name: "Index",
									type: "symbol",
									defval: "HKEX:HSI"
								},
								{
									id: "rsLineVerticalOffset",
									name: "Vertical offset of RS Line",
									type: "integer",
									defval: 1,
									step: 1
								},
								{
									id: "recentHighLookback",
									name: "Recent high look-back count",
									type: "integer",
									defval: 52,
									min: 10,
									max: 200,
								},
							],
						},
						constructor: function() {
							this.scaleBetween = function(unscaledNum, minAllowed, maxAllowed, min, max) {
								return (maxAllowed - minAllowed) * (unscaledNum - min) / (max - min) + minAllowed;
							}

							this.init = function(context, inputCallback) {
								this._context = context;
								this._input = inputCallback;
								this._hsiClosePriceList = [ ];
								this._closePriceList = [ ];
								this._ratioList = [ ];
								this._resultList = [ ];
								this._highestPrice = -1;
								this._lowestPrice = 9999999;
								this._highestRS = -1;
								this._lowestRS = 9999999;
								this._currentIndex = 0;

								var index = this._input(0);
								var period = PineJS.Std.period(this._context);

								this._context.new_sym(PineJS.Std.ticker(this._context), period);
								this._context.new_sym(index, period);
							}

							this.main = function(context, inputCallback) {
								this._context = context;
								this._input = inputCallback;
								var offset = this._input(1);

								this._context.select_sym(2);
								var hsiIndexClose = PineJS.Std.close(this._context);
								var hsiTime = PineJS.Std.time(this._context, PineJS.Std.period(this._context));

								if (!isNaN(hsiIndexClose) && !isNaN(hsiTime)) {
									if (this._hsiClosePriceList.filter(c => c.time == hsiTime).length == 0) {
										this._hsiClosePriceList.push({ 
											time: hsiTime,
											close: hsiIndexClose,
										});
									}
								}

								this._context.select_sym(1);
								var close = PineJS.Std.close(this._context);
								var time = PineJS.Std.time(this._context, PineJS.Std.period(this._context));
								var low = PineJS.Std.low(this._context);
								var high = PineJS.Std.high(this._context);

								if (!isNaN(close) && !isNaN(time)) {
									if (this._closePriceList.filter(c => c.time == time).length == 0) {
										this._closePriceList.push({ 
											time: time,
											close: close,
										});
									}

									if (low < this._lowestPrice) {
										this._lowestPrice = low;
									}

									if (high > this._highestPrice) {
										this._highestPrice = high;
									}
								}

								this._context.select_sym(0);
								var close2 = PineJS.Std.close(this._context);
								var time2 = PineJS.Std.time(this._context, PineJS.Std.period(this._context));

								if (!isNaN(close) && !isNaN(time) && isNaN(close2) && isNaN(time2)) {
									var newCloseHigh = false;

									var recentCloseHigh = 0;
									var indexOfCloseHigh = 0;

									for (var i = this._currentIndex; i >= Math.max(this._currentIndex - this._input(2), 0); i--) {
										if (this._closePriceList[i].close > recentCloseHigh) {
											recentCloseHigh = this._closePriceList[i].close;
											indexOfCloseHigh = i;
										}
									}

									if (this._currentIndex == indexOfCloseHigh) {
										newCloseHigh = true;
									}

									var hsiClosePriceList = this._hsiClosePriceList.filter(c => c.time == time);

									if (hsiClosePriceList.length > 0) {
										var ratio = (close / hsiClosePriceList[0].close) * 100;

										this._ratioList.push(ratio);

										var newRatioHigh = false;

										var recentRatioHigh = 0;
										var indexOfRatioHigh = 0;

										for (var i = this._currentIndex; i >= Math.max(this._currentIndex - this._input(2), 0); i--) {
											if (this._ratioList[i] > recentRatioHigh) {
												recentRatioHigh = this._ratioList[i];
												indexOfRatioHigh = i;
											}
										}

										if (this._currentIndex == indexOfRatioHigh) {
											newRatioHigh = true;
										}

										if (ratio > this._highestRS) {
											this._highestRS = ratio;
										}

										if (ratio < this._lowestRS) {
											this._lowestRS = ratio;
										}

										this._resultList.push({
											time: time,
											ratio: ratio,
											newRatioHigh: newRatioHigh,
											newCloseHigh: newCloseHigh,
										});
									}

									this._currentIndex++;
								}

								if (!isNaN(close2) && !isNaN(time2)) {
									var result = this._resultList.filter(r => r.time == time2);

									if (result.length > 0) {
										var ratio = this.scaleBetween(result[0].ratio / RS_LINE_SCALE, this._lowestPrice / RS_LINE_SCALE, (this._lowestPrice + this._highestPrice) / 2, this._lowestRS / RS_LINE_SCALE, this._highestRS / RS_LINE_SCALE);

										return [ ratio, ((result[0].newRatioHigh && !result[0].newCloseHigh) ? ratio : NaN) ];
									}
								}
							}
						}
					}
				]);
			},
		};

		const tvWidget = new widget(widgetOptions);
		this.tvWidget = tvWidget;
		window.tvWidget = tvWidget;

		datafeed.setWidget(tvWidget);

		if (this.props.streamingApi) {
			this.props.streamingApi.setWidget(tvWidget);
		}

		tvWidget.onChartReady(() => {
			this.props.onReadyCallback();

			this.onChartReady(true);

			tvWidget.chart().onSymbolChanged().subscribe(null, () => {
				tvWidget.chart().onDataLoaded().subscribe(null, () => {
					this.onChartReady();
				}, true);
			});

			tvWidget.chart().onIntervalChanged().subscribe(null, (interval, timeframeObj) => {
				this.createStudies(interval);
			});
		});
	}

	onChartReady()
	{
		setTimeout(() => {
			var from = this.tvWidget.chart().getVisibleRange().from;
			var to = this.tvWidget.chart().getVisibleRange().to;

			var diff = to - from;

			from = (diff / 60 / 60 / 24) < 60 ? (to - (60 * 60 * 24 * 90)) : from;

			this.tvWidget.chart().setVisibleRange({
				from: from,
				to: to,
			}, {
				percentRightMargin: 0,
			});

			this.tvWidget.chart().setPriceToBarRatio(this.tvWidget.chart().getPriceToBarRatio() * PRICE_SCALE);

			this.createStudies(this.tvWidget.chart().resolution());
		}, 1);
	}

	onPatternCallback(patternData)
	{
		if (this.tvWidget !== null) {
			var chart = this.tvWidget.activeChart();

			this.patterns.forEach(patternId => {
				chart.removeEntity(patternId);
			});

			this.patterns = [];

			for (var i = 0; i < patternData.length; i++) {
				var patternId = chart.createMultipointShape(patternData[i].points, patternData[i].options);
				this.patterns.push(patternId);
			}
		}
	}

	async createStudies(interval)
	{
		if (this.volumeMaEntityId != null) {
			this.tvWidget.chart().removeEntity(this.volumeMaEntityId);
		}

		if (this.priceMaEntityId != null) {
			this.tvWidget.chart().removeEntity(this.priceMaEntityId);
		}

		if (this.rsLineEntityId != null) {
			this.tvWidget.chart().removeEntity(this.rsLineEntityId);
		}

		var days = interval[1] === "D" ? 50 : 10;

		this.tvWidget.chart().createStudy("Volume", true, true, [], { "volume ma.visible": true, "ma length": days, }).then((entityId) => {
			this.volumeMaEntityId = entityId
		});

		this.tvWidget.chart().createStudy("Moving Average", false, true, [days]).then((entityId) => {
			this.priceMaEntityId = entityId
		});

		if (!this.props.hideRSLine && !indices.includes(this.tvWidget.chart().symbol())) {
			try {
				var data = await apiHelper.request(
					this.props.getAccessTokenSilently,
					window.location,
					"tvchart/rsline",
					"GET"
				);
	
				var rsLineLookback;
	
				switch (interval[1]) {
					case "W":
						rsLineLookback = 52;
						break;
					case "M":
						rsLineLookback = 12;
						break;
					default:
						rsLineLookback = 200;
						break;
				}
	
				if (data.status === "success") {
					this.tvWidget.chart().createStudy("RS Line", false, false, [ "HKEX:HSI", 100, rsLineLookback ]).then((entityId) => {
						this.rsLineEntityId = entityId
					});
				}
			} catch (e) {
	
			}
		}
	}

	componentWillUnmount()
	{
		if (this.tvWidget !== null) {
			this.tvWidget.remove();
			this.tvWidget = null;
		}
	}

	render()
	{
		return (
			<div
				id={ this.props.containerId }
				className={ this.props.className }
			/>
		);
	}
}
